import React from 'react';

import {
  CloseIcon,
  CmBaseTable,
  CmButton,
  CmFlex,
  CmTableBodyRow,
  CmTd,
  CmText,
  SendIcon,
} from '@/components/uiParts';
import { DeliveryServiceBadge } from '@/pages/externals/mos-pos-resend/components/Badges';
import {
  CANCEL_BUTTON_BG,
  displayOrEmpty,
  formatDateTime,
  formatPrice,
  listTableThs,
  RESEND_BUTTON_BG,
  RESEND_BUTTON_HOVER_BG,
  ROW_HOVER_BG,
} from '@/pages/externals/mos-pos-resend/service';
import { MosPosOrderListItem } from '@/services/MosPosOrder/type';

type Props = {
  items: MosPosOrderListItem[];
  onRowClick: (row: MosPosOrderListItem) => void;
  onResendClick: (row: MosPosOrderListItem) => void;
  onCancelClick: (row: MosPosOrderListItem) => void;
};

export const MosPosOrderTable: React.VFC<Props> = ({
  items,
  onRowClick,
  onResendClick,
  onCancelClick,
}) => {
  /** 行クリックとボタンクリックで二重遷移しないよう伝播を止める */
  const handleActionClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    action: () => void
  ) => {
    event.stopPropagation();
    action();
  };

  return (
    <CmBaseTable ths={listTableThs}>
      {items.map((item) => (
        <CmTableBodyRow
          key={item.order_id}
          cursor="pointer"
          _hover={{ bg: ROW_HOVER_BG }}
          onClick={() => onRowClick(item)}
        >
          <CmTd>
            <CmText fontFamily="mono" fontWeight="bold">
              {item.web_order_id}
            </CmText>
          </CmTd>
          {/* 店舗名末尾の「店」は省略しない */}
          <CmTd>
            {`${item.store_code} - ${displayOrEmpty(item.store_name)}`}
          </CmTd>
          <CmTd>
            <DeliveryServiceBadge
              deliveryServiceId={item.delivery_service_id}
            />
          </CmTd>
          <CmTd>{formatDateTime(item.order_date_and_time)}</CmTd>
          <CmTd>{formatDateTime(item.pickup_time)}</CmTd>
          <CmTd textAlign="right">{formatPrice(item.payment_amount)}</CmTd>
          <CmTd>
            <CmFlex gridGap="8px">
              {item.can_resend && (
                // @ts-ignore TS2590
                <CmButton
                  size="sm"
                  bg={RESEND_BUTTON_BG}
                  color="white"
                  _hover={{ bg: RESEND_BUTTON_HOVER_BG }}
                  leftIcon={<SendIcon boxSize={3} />}
                  onClick={(event) =>
                    handleActionClick(event, () => onResendClick(item))
                  }
                >
                  再送信
                </CmButton>
              )}
              {item.can_cancel && (
                // @ts-ignore TS2590
                <CmButton
                  size="sm"
                  colorScheme="red"
                  bg={CANCEL_BUTTON_BG}
                  leftIcon={<CloseIcon boxSize={2.5} />}
                  onClick={(event) =>
                    handleActionClick(event, () => onCancelClick(item))
                  }
                >
                  取消
                </CmButton>
              )}
            </CmFlex>
          </CmTd>
        </CmTableBodyRow>
      ))}
    </CmBaseTable>
  );
};
